import React from 'react';
import classNames from 'classnames';

const StepNavItem = ({ index, currentStep, title, length = 0, onSelect }) => {
    const isCurrent = index === currentStep;
    // Only earlier steps can be opened from the bar. Going forward always
    // goes through the step's own Continue button, which saves what the
    // customer changed on this step (a jump would skip that save).
    const canGo = !!onSelect && index < currentStep;
    const componentClass = classNames('nav-item step-nav-item', {
        active: isCurrent,
        done: index < currentStep,
        reachable: canGo
    });
    const content = (
        <React.Fragment>
            <i className="far fa-circle icon pending-icon" />
            <i className="far fa-check-circle icon check-icon" />
            <span className="step-label">{title}</span>
        </React.Fragment>
    );

    return (
        <li className={componentClass}>
            {canGo ? (
                <button
                    type="button"
                    className="content step-nav-button"
                    title={title}
                    aria-label={`Go to step ${index}: ${title}`}
                    onClick={() => onSelect(index)}
                >
                    {content}
                </button>
            ) : (
                <div
                    className="content"
                    title={title}
                    aria-current={isCurrent ? 'step' : undefined}
                >
                    {content}
                </div>
            )}
            {index !== length && <div className="conector" />}
        </li>
    );
};

export default StepNavItem;
